import CalendarCheck from './calendar-check.svg';
import CalendarDay from './calendar-day.svg';
import Calendar from './calendar.svg';
import ClipFile from './clip-file.svg';
import Clock from './clock.svg';
import CommentsQuestionCheck from './comments-question-check.svg';
import CommentsQuestion from './comments-question.svg';
import Comments from './comments.svg';
import MemoCircleCheck from './memo-circle-check.svg';
import Memo from './memo.svg';
import TimeCheck from './time-check.svg';
import TimeQuarterPast from './time-quarter-past.svg';
import UsersAlt from './users-alt.svg';
import AngleSmallRight from './angle-small-right.svg';
import FileMedicalAlt from './file-medical-alt.svg';

export {
  AngleSmallRight,
  Calendar,
  CalendarCheck,
  CalendarDay,
  ClipFile,
  Clock,
  Comments,
  CommentsQuestion,
  CommentsQuestionCheck,
  FileMedicalAlt,
  Memo,
  MemoCircleCheck,
  TimeCheck,
  TimeQuarterPast,
  UsersAlt,
};
